import { EventEmitter } from "events";

import Dispatcher from "./dispatcher";
import Constants from "./constants";
import getSidebarNavItems from "../data/sidebar-nav-items";
import { getInitialTheme, applyThemeAttribute } from "../utils/theme";

let _store = {
  menuVisible: false,
  navItems: getSidebarNavItems(),
  sidebarCollapsed: window.localStorage.getItem("sidebarCollapsed") === "true",
  theme: getInitialTheme()
};

class Store extends EventEmitter {
  constructor() {
    super();

    this.registerToActions = this.registerToActions.bind(this);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.toggleSidebarCollapse = this.toggleSidebarCollapse.bind(this);
    this.toggleTheme = this.toggleTheme.bind(this);

    Dispatcher.register(this.registerToActions.bind(this));
  }

  registerToActions({ actionType, payload }) {
    switch (actionType) {
      case Constants.TOGGLE_SIDEBAR:
        this.toggleSidebar();
        break;
      case Constants.TOGGLE_SIDEBAR_COLLAPSE:
        this.toggleSidebarCollapse();
        break;
      case Constants.TOGGLE_THEME:
        this.toggleTheme();
        break;
      default:
    }
  }

  toggleSidebar() {
    _store.menuVisible = !_store.menuVisible;
    this.emit(Constants.CHANGE);
  }

  toggleSidebarCollapse() {
    _store.sidebarCollapsed = !_store.sidebarCollapsed;
    window.localStorage.setItem("sidebarCollapsed", String(_store.sidebarCollapsed));
    this.emit(Constants.CHANGE);
  }

  toggleTheme() {
    _store.theme = _store.theme === "dark" ? "light" : "dark";
    window.localStorage.setItem("theme", _store.theme);
    applyThemeAttribute(_store.theme);
    this.emit(Constants.CHANGE);
  }

  getMenuState() {
    return _store.menuVisible;
  }

  getSidebarItems() {
    return _store.navItems;
  }

  getSidebarCollapsed() {
    return _store.sidebarCollapsed;
  }

  getTheme() {
    return _store.theme;
  }

  addChangeListener(callback) {
    this.on(Constants.CHANGE, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(Constants.CHANGE, callback);
  }
}

export default new Store();
